export enum ProcedureType {
  CooperativeTraining,
  ExperienceTraining,
  ExcellenceTraining,
  PractitionersTraining,
  TrainingRequest,
  AttendanceRequest,
  TrainingNeeds
}
